/**
 * Update total price in Cart
 */
export default class TotalPrice {
  public static execute(totalCartFormated: string): void {
    const totalPriceElement: HTMLElement = document.querySelector(
      '.c-cartHeader__total--price'
    );

    totalPriceElement.innerHTML = totalCartFormated;

    // Delivery percentage
    /* if (document.querySelector('.c-cartHeader__delivery')) {
      DeliveryCartHeader.execute(totalCart);
    } */
  }
}
